<template>
  <div class="search" v-hotkey="keymap">
    <div class="container pt-3 pt-md-0">
      <spinner v-if="loading"></spinner>
      <div class="row h-100 mt-3 border mx-0">
        <div class="col-sm-1 bg-background p-0" >
          <button 
            @click="showUppy = false"
            :class="!showUppy ?'bg-white text-primary': 'bg-transparent text-dark'"
            class="border-0 w-100 py-3"
            >
            <i class="fas fa-edit"></i>
            <small class="d-block">{{this.hebrew ? 'תיבת טקסט' : 'Type text'}}</small>
          </button>
          <button 
            @click="showUppy = true"
            :class="showUppy ?'bg-white text-primary': 'bg-transparent text-dark'"
            class="border-0 w-100 py-3"
             >
            <i class="fas fa-folder-open"></i>
            <small class="d-block">{{this.hebrew ? 'העלאת קובץ' : 'Upload file'}}</small>
          </button>

        </div>
        <div class="col-sm-8 bg-white py-3">
          <div
            class="h-100 bg-white text-wrap position-relative"
          >
            <div
              class="erase position-absolute p-2"
              id = "del-btn"
              v-if="searchText && searchText !== ''"
              @click="clearText"
            >
              <span aria-hidden="true">&times;</span>
            </div>
            <textarea
              v-if="!showUppy"
              id="textEntryArea"
              ref="textArea"
              @focus="focusedEvent"
              @focusout="focusedOutEvent"
              dir="rtl"                       
              class="f-narkis w-100 py-0 px-2 rounded text-right border-dark h-100"
              :placeholder="hebrew ? 'הזינו טקסט כאן' : 'Enter Hebrew text' "
              v-model="searchText"
            ></textarea>
            <upload-files @upload-complete="uppyComplete=true" v-show="showUppy"/>
           </div>
        </div>
        <div class="col-sm-3 px-0 bg-background">
          <div class="rounded position-relative">
            <text-settings></text-settings>
          </div>
          <server-failed-popup v-if="failed" v-model="failed"  :msg="errorMessage"  />
          <button
              :disabled="showUppy && !uppyComplete"
              id="run-morphology"
              class="run-btn btn btn-primary d-block position-absolute"
              @click="search"
          >{{hebrew ? 'החל ניתוח מורפולוגי' : 'Morphological Analysis'}}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Actions } from "@/store/stateChanges"
import { RunStates } from "@/store/runStates"
import Spinner from "@/components/spinner"
import TextSettings from "@/components/TextSettings"
import UploadFiles from "@/components/UploadFiles"
import ServerFailedPopup from "@/components/ServerFailedPopup"


export default {
  name: "Search",
  props: {},
  components: { Spinner, ServerFailedPopup, TextSettings, UploadFiles },
  data() {
    return {
      searchText: '',
      emptyText: false,
      errorMessage: null,     
      showUppy: false,
      uppyComplete: false      
    }
  },
  mounted: function() {
    if (this.$route.query.tab && this.$route.query.tab === 'upload') {
      this.showUppy = true
    }
    else if(this.$route.query.status) {
      this.$router.push({ name: "CheckStatus", query: { id: this.$route.query.status }})
    } 
    else if (this.uploadedFiles.length > 0) {
      this.showUppy = true
      this.uppyComplete = true
    } 
  },
  computed: {
    keymap () {
      return {
        'ctrl+enter': () => {
          this.search()
        }
      }
    },
    hebrew () {
      return this.$settings.hebrew
    },
    loading () {
      return this.$store.state.morphApiState === RunStates.RUNNING;
    },
    failed: {
      get () {
        return this.$store.state.morphApiState === RunStates.FAILED ||
          this.$store.state.morphApiState === RunStates.TIMED_OUT
      },
      set () {
        this.errorMessage = null
        this.$store.commit('MORPH_NOT_RUN')
      }
    },
    uploadedFiles () {
      return this.$store.state.urlList
    }    
  },

  methods: {
    focusedEvent () {      
      this.$refs.textArea.classList.remove('border-dark')
      this.$refs.textArea.classList.add('border-primary')
    },
    focusedOutEvent () {      
      this.$refs.textArea.classList.remove('border-primary')
      this.$refs.textArea.classList.add('border-dark')
    },
    clearText () { //value former param
      //if (value.clicked || this.DontAskAgain) {
        this.$store.commit("SET_TEXT_FOR_API_CALL", "");
        this.searchText = "";
        this.$refs.textArea.focus();
      //}
    },
    search () {
      if (this.showUppy)
        this.$router.push({ name: "EmailForm" })
      else {  
        if (this.searchText.length < 10000 && this.searchText.length > 0 ) {
          this.$store.commit("SET_TEXT_FOR_API_CALL", this.searchText);
          this.$store.dispatch(Actions.RUN_TEXT_MORPH)
        } else {
          this.$store.commit('MORPH_FAILED')
          this.errorMessage = this.hebrew ? 'אפשר להעלות טקסט של עד 10,000 תווים' : 'Exceeded maximum text of 10,000 chars'
        }
      }
    }
  }
};
</script>

<style scoped lang=scss>
.container {
  height: calc(100vh - 120px);
  position: relative;
  z-index: 2;
  .row {
    border-radius: 6px;
  }
}
button {
  outline: none!important;
  i {
    font-size: 25px;
  }
}
.erase {
  left: 5px;
  top: 0;
  font-size: 20px;
  @media only screen and (max-width: 991px) {
    span {
      font-size: 34px;
    }
  }
}
textarea {  
  direction: rtl;
  font-size: 25px;
  overflow-y: auto;
  scrollbar-width: none; /* Firefox */
  -ms-overflow-style: none; /* IE 10+ */
  &::-webkit-scrollbar {
    width: 0px;
    background: transparent; /* Chrome/Safari/Webkit */
  }
  resize: none;
  &:focus {
    outline: none;
  }
}
.rounded {
  border-radius: 4px!important;
}
.run-btn {
  bottom: 15px;
  left: 15px;
  height: 36px;
  font-size: 16px;
  width: calc(100% - 30px);
}
</style>
